import { render, staticRenderFns } from "./DependentOfficialVisa.vue?vue&type=template&id=4fbf0dd8&"
import script from "./DependentOfficialVisa.vue?vue&type=script&lang=js&"
export * from "./DependentOfficialVisa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports